module.exports = __webpack_public_path__ + "static/media/demo.6318aa84.jpg";